export default "__VITE_ASSET__967kDoBj__"